export const NOTIFICATION_TYPE_FILTER_OPTIONS = [
  { value: "all", label: "ທຸກປະເພດ" },
  { value: "wallet.topup.submitted", label: "ເຕີມເງິນ" },
  { value: "wallet.kyc.submitted", label: "KYC" },
  { value: "compliance.suspicious.pending", label: "ຄວາມສົງໄສ" },
] as const;

export const NOTIFICATION_TYPE_LABELS: Record<string, string> = {
  "wallet.topup.submitted": "ເຕີມເງິນ",
  "wallet.kyc.submitted": "KYC",
  "compliance.suspicious.pending": "ຄວາມສົງໄສ",
};

export function notificationTypeLabel(type: string): string {
  return NOTIFICATION_TYPE_LABELS[type] ?? type;
}
